/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";

export const newAppStoryMediaSchema = z
	.object({
		url: z.string(),
		media_type: z.string().describe("image или video."),
	})
	.describe("Медиа истории.");
